<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      その他
    </Header>
    <div class="mypage py-3">
      <div class="section px-3 pt-4 mt-2">
        <div class="bg-white border border-outline-color px-3 mt-1 round-4">
          <a
            :href="ruleLink"
            class="d-flex justify-content-between align-items-center py-3"
          >
            <p class="text-size-14">利用規約</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </a>
          <a
            :href="externalLink.PRIVACY"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">プライバシーポリシー</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </a>
          <a
            :href="externalLink.OCCUPATIONS"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">取扱職種の範囲等</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </a>
          <RouterLink
            :to="{ name: 'LeaveConfirmation' }"
            class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          >
            <p class="text-size-14">退会</p>
            <div class="d-flex justify-content-end align-items-center">
              <FeatherIcon
                icon="chevron-right"
                size="1x"
                class="text-gray-05 ml-2"
              />
            </div>
          </RouterLink>
        </div>
      </div>
      <AppFooter />
      <BlockBack />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { routerPush } from "@/utils/routerPush";
import ExternalLink from "@/const/externalLink";
import { authStore } from "@/store/auth";

@Component({
  components: {
    FeatherIcon,
    Header,
    AppFooter,
    BlockBack
  }
})
export default class OtherAccountInfo extends Vue {
  get externalLink() {
    return ExternalLink;
  }

  get ruleLink() {
    return authStore.isCaitechPharmacistProduct
      ? this.externalLink.RULE_CAITECH_PHARMACIST
      : this.externalLink.RULE;
  }

  async created() {
    await sendAdjustEvent("SHOW_ACCOUNT_OTHER_INFO");
  }

  async onClickBack() {
    await routerPush(this, { name: "AccountInfo" });
  }
}
</script>

<style lang="scss" scoped>
.mypage {
  position: relative;

  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}
</style>
